import { render } from "./ProfileLayout.vue?vue&type=template&id=aa50419c&scoped=true"
import script from "./ProfileLayout.vue?vue&type=script&lang=js"
export * from "./ProfileLayout.vue?vue&type=script&lang=js"

import "./ProfileLayout.vue?vue&type=style&index=0&id=aa50419c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa50419c"]])

export default __exports__